import styles from './ErrorContent.module.scss';
import { ErrorModalContent } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { useSelector } from 'store/utils';

type Props = {
  onConfirm(): void;
};

export const ErrorContent = ({ onConfirm }: Props) => {
  const errorMessage = useSelector(selectModalsErrors).editUserError;

  return (
    <ErrorModalContent
      title="User information is not changed"
      subtitle={`The user was not updated${errorMessage ? `. ${errorMessage}` : ' due to technical errors'}`}
      contentContainerClassname={styles.errorModalContentContainer}
      onConfirm={onConfirm}
    />
  );
};
